/**
 * Downloads a file with a given filename
 * @param {string} filename
 * @param {string} content
 * @param {string} filetype
 */
export function download(filename: string, content: string, filetype?: string) {
  const pom = document.createElement('a');
  let data = content;
  if (filetype) {
    data = `data:text/${filetype};charset=utf-8,` + encodeURIComponent(content);
  }
  pom.setAttribute('href', data);
  pom.setAttribute('download', filename);
  pom.click();
}

/**
 * @param {File} originalFile file to rename
 * @param {string} newName new filename
 * @return {File} renamed file
 */
export function renameFile(originalFile: File, newName: string): File {
  return new File([originalFile], newName, {
    type: originalFile.type,
    lastModified: originalFile.lastModified,
  });
}

/**
 * Downloads a file from a Blob given a filename and a file
 * @param {string} filename
 * @param {string} content
 * @param {string} filetype
 */
export function downloadFromBlob(filename: string, content: Blob) {
  const blobUrl = window.URL.createObjectURL(content);

  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = filename;
  link.click();

  window.URL.revokeObjectURL(blobUrl);
}
